import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from "rxjs";

@Component({
  selector: 'app-fixed-usage',
  templateUrl: './fixed-usage.component.html',
  styleUrls: ['./fixed-usage.component.sass']
})
export class FixedUsageComponent implements OnInit {
  public tabActive = 'usage';
  public selectBan;
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public type;
  
  @Input() index;
  @Input() prodType;
  @Input() useminvoice;
  @Input() useminLD;
  @Input() useminLDI;
  @Input() smsmms;
  @Input() smsprem;
  @Input() mms;
  public SubscriberInfo = [];
  public token: string = sessionStorage.getItem("token");
  loadObserver: Subscription;
  public info = [];
  constructor(private router: Router, public dialog: MatDialog, private route: ActivatedRoute) { }
  ngOnInit() {
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
  }
  refreshDataTo() {
    let index = parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan", btoa(ban));
    this.initializeData();
  }
  initializeData() {
    alert
  }
  dataLoading(sw) {
    if (this.postpago == true) {
      this.type = "postpaid";
    }
    else if (this.prepago == true) {
      this.type = "prepaid";
    }
    else if (this.telefoniaFijo == true) {
      this.type = "fixed";
    }
    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
  }
}